export class Detail {
  id: number;
  intranet_id: number;
  matter_id: number;
  position: number;
  value: any;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  detail_type_id: number;
  detail_type_name: string;
  editing: boolean = false;
  deleting: boolean = false;
}
